import SEO from "../designSystem/SEO";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import Hero from "../designSystem/Hero";

const OtherServicesPage = () => (
  <main>
    <SEO
      title="Other Services"
      description="Explore the range of other services offered by CAPC."
      path="/other-services"
    />
    <Hero wantOverlay={false}>
      <div id="residential-mortgages" className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">Our services</div>
          <h1 className="text-primary-1 text-center">Other Services</h1>
          <div className="column gap-m">
            <div className="content text-primary-2 text-center">
              At CAPC, our support extends beyond arranging your mortgage.
              Through our trusted network of professional partners, we can
              connect you with experienced specialists to support every stage of
              your property journey, from legal and financial advice to
              property-related services.
            </div>
            <div className="content text-primary-2 text-center">
              Each of our recommended partners has been carefully selected for
              their expertise, professionalism and commitment to delivering
              excellent client service. If you'd like an introduction, our team
              will be happy to help.
            </div>
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>

    <section className="background-container bg-white">
      <div className="content-container">
        <div className="column-center text-center">
          <div className="content text-primary-2">
            You are now departing from the regulatory site of Christopher Allen
            Private Clients Limited. Neither Christopher Allen Private Clients
            Limited Nor Rosemount Financial Solutions (IFA) Ltd are responsible
            for the accuracy of the information contained within the linked
            site.
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default OtherServicesPage;
